import React from 'react';

import AboutBusiness from './business-information/about-business';
import BusinessLocation from './business-information/business-location';

const KybUpdateChangeRequest = () => {
  return (
    <div className='grid gap-8'>
      <AboutBusiness />
      <BusinessLocation />
    </div>
  );
};

export default KybUpdateChangeRequest;
